module.exports = __webpack_public_path__ + "static/paris-002-64eb68cf4d2be2e24725cc63835d2523.jpg";